var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Downshift from 'downshift';
import React, { Component } from 'react';
import styled from 'react-emotion';
import { DropdownWrapper, ListItem, ListTitle, SelectContainer, StyledCarrot, StyledCheck } from './Components';
import MultiSelectList from './SelectComponents/MultiSelectList';
import SelectList from './SelectComponents/SelectList';
export const TopListItem = styled(ListItem) `
  :focus {
    border: 1px solid #c7c7c7;
    outline: none;
  }
`;
let SelectDropdown = /** @class */ (() => {
    class SelectDropdown extends Component {
        constructor() {
            super(...arguments);
            this.stateReducer = (_state, changes) => {
                switch (changes.type) {
                    case Downshift.stateChangeTypes.clickItem:
                        return Object.assign(Object.assign({}, changes), { isOpen: true });
                    default:
                        return changes;
                }
            };
            this.onSelect = (item) => {
                const { multiSelect, onChange, selectedItems } = this.props;
                if (!selectedItems)
                    return;
                if (multiSelect) {
                    let newSelectedItems = [];
                    if (selectedItems.some(currentItem => currentItem.value === item.value)) {
                        newSelectedItems = selectedItems.filter(itemToFilter => itemToFilter.value !== item.value);
                    }
                    else {
                        newSelectedItems = [...selectedItems, item];
                    }
                    onChange && onChange(newSelectedItems);
                }
                else {
                    this.selectItem(item);
                }
            };
            this.selectItem = (item) => {
                const { onChange } = this.props;
                onChange && onChange(item);
                item.props && item.props.onClick && item.props.onClick();
            };
            this.itemToString = (item) => {
                return item ? item.text || item.value : '';
            };
        }
        componentDidMount() {
            const { defaultSelectedItem } = this.props;
            if (defaultSelectedItem) {
                const item = this.props.items.find(item => item.value === this.props.defaultSelectedItem.value ||
                    item.id === this.props.defaultSelectedItem.value);
                item && this.selectItem(item);
            }
        }
        render() {
            const _a = this.props, { items, title, SelectComponent, multiSelect, CustomCarrot = StyledCarrot, CustomCheck = StyledCheck, id } = _a, props = __rest(_a, ["items", "title", "SelectComponent", "multiSelect", "CustomCarrot", "CustomCheck", "id"]);
            return (React.createElement(Downshift, { stateReducer: multiSelect ? this.stateReducer : undefined, onSelect: this.onSelect, itemToString: this.itemToString, render: ({ getToggleButtonProps, getItemProps, isOpen, getRootProps, highlightedIndex }) => {
                    const { selectedItem, defaultSelectedItem, selectedItems } = this.props;
                    return (React.createElement(SelectContainer, Object.assign({}, getRootProps({ refKey: 'innerRef' }), props),
                        React.createElement(TopListItem, Object.assign({ type: "button", className: "toggleSelect", id: id }, getToggleButtonProps(), { disabled: this.props.disabled || false }),
                            React.createElement(ListTitle, null,
                                '',
                                (!multiSelect && selectedItem) || defaultSelectedItem
                                    ? (selectedItem || defaultSelectedItem).text ||
                                        (selectedItem || defaultSelectedItem).value
                                    : title),
                            multiSelect && selectedItems && selectedItems.length > 0 ? (React.createElement(CustomCheck, null)) : (React.createElement(CustomCarrot, { open: isOpen }))),
                        React.createElement(DropdownWrapper, { isOpen: isOpen }, isOpen &&
                            (SelectComponent ? (React.createElement(SelectComponent, { items: items, getItemProps: getItemProps, selectedItem: selectedItem, selectedItems: selectedItems, highlightedIndex: highlightedIndex ? highlightedIndex : 0 })) : multiSelect ? (React.createElement(MultiSelectList, { items: items, getItemProps: getItemProps, selectedItems: selectedItems, highlightedIndex: highlightedIndex ? highlightedIndex : 0 })) : (React.createElement(SelectList, { items: items, getItemProps: getItemProps, selectedItem: selectedItem, highlightedIndex: highlightedIndex ? highlightedIndex : 0, showClearButton: this.props.showClearButton, id: this.props.id }))))));
                } }));
        }
    }
    SelectDropdown.defaultProps = {
        showClearButton: false,
        selectedItems: []
    };
    return SelectDropdown;
})();
export default SelectDropdown;
//# sourceMappingURL=SelectDropdown.js.map